import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { nipClient } from 'application/nip';
import { ppClient } from 'application/pp';
import { ICountry, IUser } from 'types/dto';
import { handleCommandResponseData } from 'utils/net';

export async function fetchUser(accessToken: string): Promise<IUser> {
  return ppClient.post('/auth/azure-ad', { accessToken }).then(response => response.data.data);
}

export async function fetchMeCountries(): Promise<ICountry[]> {
  return nipClient.get('/users/me/countries').then(handleCommandResponseData<ICountry[]>);
}

export function useMeCountries(options?: UseQueryOptions<ICountry[]>) {
  return useQuery<ICountry[]>(['me', 'countries'], fetchMeCountries, options);
}
